export default __webpack_public_path__ + "static/touhoku-1641623216211aa937f7ea99dde49077.jpg";